import React, { useState, useCallback } from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  CircularProgress,
  Button,
  IconButton,
  TextField,
  MenuItem,
  ListItemText,
  Snackbar,
  Alert,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import { API, graphqlOperation } from "aws-amplify";
import { createBankDetails, createUserPreference } from "../../graphql/mutations";
import { IfscFetch } from "../../library/IfscFetch";
import {
  listAccountGroupMaster,
  listAccountMaster,
  listBankDetails,
} from "../../graphql/queries";
import { showWarningSnackbar } from "../snackBar/snakbar";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  // p: 4,
  outline: "none",
  minWidth: "500px",
};
const AccountTypes = [
  { option: "Current Account", value: "1" },
  { option: "Savings Account", value: "2" },
  { option: "Overdraft", value: "3" },
];

const AddBankAccount = ({
  open,
  setOpen,
  setsuccessSnakbar,
  setSnakbarText,
  setWarningSnakbar,
  setWarningText,
  accountName,
  setNewAddedAcccount,
  groupName,
  setState1,
  msg,
  paymentMethod,
  setNewAccID,
  companyDetails,
  itemEntry
}) => {
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listOfBanks, setListOfBanks] = useState([]);
  const [ledger, setLedger] = useState([]);
  const [state, setState] = useState({
    name: "",
    bankName: "",
    bankAccountNo: "",
    ifscCode: "",
    accountType: "",
    branch: "",
    errorStatus: {
      name: false,
      bankName: false,
      bankAccountNo: false,
      ifscCode: false,
      accountType: false,
      branch: false,
    },
    errorFields: {
      name: "",
      bankName: "",
      bankAccountNo: "",
      ifscCode: "",
      branch: "",
      accountType: "",
    },
  });
  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "name") {
      value = value
        ?.toLowerCase()
        .replace(/\b\w/g, (match) => match.toUpperCase());
    }
    if (value == "") {
      setState((prev) => ({
        ...prev,
        [name]: value,
        ["errorStatus"]: {
          ...prev.errorStatus,
          [name]: true,
        },
        ["errorFields"]: {
          ...prev.errorFields,
          [name]: name + " is Required",
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        [name]: value,
        ["errorStatus"]: {
          ...prev.errorStatus,
          [name]: false,
        },
        ["errorFields"]: {
          ...prev.errorFields,
          [name]: "",
        },
      }));
    }
  };

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setState((prev) => ({
        ...prev,
        name: "",
        bankName: "",
        bankAccountNo: "",
        ifscCode: "",
        accountType: "",
        branch: "",
        errorStatus: {
          name: false,
          bankName: false,
          bankAccountNo: false,
          ifscCode: false,
          accountType: false,
          branch: false,
        },
        errorFields: {
          name: "",
          bankName: "",
          bankAccountNo: "",
          ifscCode: "",
          accountType: "",
          branch: "",
        },
      }));
      setLoading(false);
      setOpen(false);
    }
  };

  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };
    const numberRegex = /^\d+(\.\d{1,2})?$/;
    Object.keys(data)?.map((key) => {
      if (key === "name") {
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.name = "Name is required";
          obj.errorStatus.name = true;
        } else {
          let uniqueValid = true
          ledger.map((item) => {
            if (item.AccountName.toLowerCase() == state.name.toLowerCase()) {
              uniqueValid = false;
            }
          });
          if (uniqueValid == false) {
            isvalid = false
            obj.errorFields.name = "Ledger Account Name is already exists";
            obj.errorStatus.name = true;
          } else {
            obj.errorFields.name = "";
            obj.errorStatus.name = false;
          }
        }
      }
      if (key === "bankName") {
        if (data[key] == "") {
          isvalid = false;
          obj.errorFields.bankName = "Bank Name is required";
          obj.errorStatus.bankName = true;
        } else {
          obj.errorFields.bankName = "";
          obj.errorStatus.bankName = false;
        }
      }
      if (key === "bankAccountNo") {
        if (data[key] == "") {
          isvalid = false;
          obj.errorFields.bankAccountNo = "Bank Account Number is required";
          obj.errorStatus.bankAccountNo = true;
        } else {
          if (!new RegExp(/^^\d{9,34}$/).test(data[key])) {
            isvalid = false;
            obj.errorFields.bankAccountNo = "Invalid Bank Account No";
            obj.errorStatus.bankAccountNo = true;
          } else {
            obj.errorFields.bankAccountNo = "";
            obj.errorStatus.bankAccountNo = false;
          }
        }
      }
      if (key === "accountType") {
        if (data[key] == "") {
          isvalid = false;
          obj.errorFields.accountType = "Bank Account Type is required";
          obj.errorStatus.accountType = true;
        } else {
          obj.errorFields.accountType = "";
          obj.errorStatus.accountType = false;
        }
      }
      if (key === "ifscCode") {
        if (data[key] == "") {
          isvalid = false;
          obj.errorFields.ifscCode = "IFSC Code is required";
          obj.errorStatus.ifscCode = true;
        } else {
          if (data[key].match("^[A-Za-z]{4}0[A-Z0-9a-z]{6}$")) {
            obj.errorFields.ifscCode = "";
            obj.errorStatus.ifscCode = false;
          } else {
            obj.errorFields.ifscCode = "Invalid IFSC";
            obj.errorStatus.ifscCode = true;
          }
        }
      }
      if (key === "branch") {
        if (data[key] == "") {
          isvalid = false;
          obj.errorFields.branch = "Branch is required";
          obj.errorStatus.branch = true;
        } else {
          obj.errorFields.branch = "";
          obj.errorStatus.branch = false;
        }
      }
    });
    setState(obj);
    return isvalid;
  }
  async function listSelectedBanKDetails() {
    try {
      const res = await API.graphql(graphqlOperation(listBankDetails));
      if (res.data.listBankDetails.length > 0) {
        res.data.listBankDetails.map((ele) => {
          if (ele.ObjectType === "COMPANY") {
            setListOfBanks(ele)
          }
        })


      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function listLedgerData() {
    try {
      const res = await API.graphql(graphqlOperation(listAccountMaster));
      setLedger(res.data.listAccountMaster);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    if (paymentMethod == "PaidTo" || paymentMethod == "ReceivedFrom" || paymentMethod == "InvoiceToAccount") {
      setState((prev) => ({
        ...prev,
        name: accountName !== "" ? accountName : "",
        errorStatus: {
          ...prev.errorStatus,
          name: false,
        },
        errorFields: {
          ...prev.errorFields,
          name: "",
        },
      }))
    }
  }, [open])
  useEffect(() => {
    if (open) {
      listLedgerData()
      listSelectedBanKDetails();
    }
  }, [open]);
  async function addBankDetails(bankDetails) {
    try {
      const res = await API.graphql(
        graphqlOperation(createBankDetails, {
          createBankDetailsInput: bankDetails,
        })
      );
      if (res.data.createBankDetails.StatusCode === "Error") {
        setWarningSnakbar(true);
        setLoading(false);
        setOpen(true)
        setWarningText(res.data.createBankDetails.StatusMessage);
      } else {
        if (listOfBanks.length === 0) {
          const userPreferenceData = {
            AdditionalValue: "",
            AttributeTypeCD: "SelectedBankDetails",
            AttributeValue: res.data.createBankDetails.BankDetailsID,
          };
          const resUserPreferenceData = await API.graphql(
            graphqlOperation(createUserPreference, {
              createUserPreferenceInput: userPreferenceData,
            })
          );
        }
        setNewAccID(
          res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID
        );
        if (msg == "Purchase") {
          if (paymentMethod !== "InvoiceToAccount") {
            setState1((prev) => ({
              ...prev,
              paidAccount: {
                label:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                value:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
              },
              errorStatus: {
                ...prev.errorStatus,
                paidAccount: false,
              },
              errorFields: {
                ...prev.errorFields,
                paidAccount: "",
              },
            }));
          } else {
            if (itemEntry) {
              setState1((prev) => ({
                ...prev,
                purchaseAccount: {
                  label:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                  value:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
                },
                errorStatus: {
                  ...prev.errorStatus,
                  purchaseAccount: false,
                },
                errorFields: {
                  ...prev.errorFields,
                  purchaseAccount: "",
                },
              }));
            } else {
              setState1((prev) => ({
                ...prev,
                ledgerAccount: {
                  label:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                  value:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
                },
                errorStatus: {
                  ...prev.errorStatus,
                  ledgerAccount: false,
                },
                errorFields: {
                  ...prev.errorFields,
                  ledgerAccount: "",
                },
              }));
            }
          }
        }
        if (msg == "Sales") {
          if (paymentMethod !== "InvoiceToAccount") {
            setState1((prev) => ({
              ...prev,
              receivedAccount: {
                label:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                value:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
              },
              errorStatus: {
                ...prev.errorStatus,
                receivedAccount: false,
              },
              errorFields: {
                ...prev.errorFields,
                receivedAccount: "",
              },
            }));
          } else {
            if (itemEntry) {
              setState1((prev) => ({
                ...prev,
                purchaseAccount: {
                  label:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                  value:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
                },
                errorStatus: {
                  ...prev.errorStatus,
                  purchaseAccount: false,
                },
                errorFields: {
                  ...prev.errorFields,
                  purchaseAccount: "",
                },
              }));
            } else {
              setState1((prev) => ({
                ...prev,
                ledgerAccount: {
                  label:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                  value:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
                },
                errorStatus: {
                  ...prev.errorStatus,
                  ledgerAccount: false,
                },
                errorFields: {
                  ...prev.errorFields,
                  ledgerAccount: "",
                },
              }));
            }
          }
        }
        if (msg == "Pos") {
          if (paymentMethod !== "InvoiceToAccount") {
            setState1((prev) => ({
              ...prev,
              receivedAccount: {
                label:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                value:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
              },
              errorStatus: {
                ...prev.errorStatus,
                receivedAccount: false,
              },
              errorFields: {
                ...prev.errorFields,
                receivedAccount: "",
              },
            }));
          } else {
            if (itemEntry) {
              setState1((prev) => ({
                ...prev,
                purchaseAccount: {
                  label:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                  value:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
                },
                errorStatus: {
                  ...prev.errorStatus,
                  purchaseAccount: false,
                },
                errorFields: {
                  ...prev.errorFields,
                  purchaseAccount: "",
                },
              }));
            } else {
              setState1((prev) => ({
                ...prev,
                ledgerAccount: {
                  label:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                  value:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
                },
                errorStatus: {
                  ...prev.errorStatus,
                  ledgerAccount: false,
                },
                errorFields: {
                  ...prev.errorFields,
                  ledgerAccount: "",
                },
              }));
            }
          }
        }
        if (msg == "Debit") {
          if (paymentMethod !== "InvoiceToAccount") {
            setState1((prev) => ({
              ...prev,
              creditToAccount: {
                label:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                value:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
              },
              errorStatus: {
                ...prev.errorStatus,
                creditToAccount: false,
              },
              errorFields: {
                ...prev.errorFields,
                creditToAccount: "",
              },
            }));
          } else {
            if (itemEntry) {
              setState1((prev) => ({
                ...prev,
                purchaseAccount: {
                  label:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                  value:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
                },
                errorStatus: {
                  ...prev.errorStatus,
                  purchaseAccount: false,
                },
                errorFields: {
                  ...prev.errorFields,
                  purchaseAccount: "",
                },
              }));
            } else {
              setState1((prev) => ({
                ...prev,
                ledgerAccount: {
                  label:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                  value:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
                },
                errorStatus: {
                  ...prev.errorStatus,
                  ledgerAccount: false,
                },
                errorFields: {
                  ...prev.errorFields,
                  ledgerAccount: "",
                },
              }));
            }
          }
        }
        if (msg == "Credit") {
          if (paymentMethod !== "InvoiceToAccount") {
            setState1((prev) => ({
              ...prev,
              creditToAccount: {
                label:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                value:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
              },
              errorStatus: {
                ...prev.errorStatus,
                creditToAccount: false,
              },
              errorFields: {
                ...prev.errorFields,
                creditToAccount: "",
              },
            }));
          } else {
            if (itemEntry) {
              setState1((prev) => ({
                ...prev,
                purchaseAccount: {
                  label:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                  value:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
                },
                errorStatus: {
                  ...prev.errorStatus,
                  purchaseAccount: false,
                },
                errorFields: {
                  ...prev.errorFields,
                  purchaseAccount: "",
                },
              }));
            } else {
              setState1((prev) => ({
                ...prev,
                ledgerAccount: {
                  label:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                  value:
                    res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
                },
                errorStatus: {
                  ...prev.errorStatus,
                  ledgerAccount: false,
                },
                errorFields: {
                  ...prev.errorFields,
                  ledgerAccount: "",
                },
              }));
            }
          }
        }
        if (msg == "Payment") {
          if (paymentMethod !== "PaidTo") {
            setState1((prev) => ({
              ...prev,
              paidFrom: {
                label:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                value:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
              },
              errorStatus: {
                ...prev.errorStatus,
                paidFrom: false,
              },
              errorFields: {
                ...prev.errorFields,
                paidFrom: "",
              },
            }));
          } else {
            setState1((prev) => ({
              ...prev,
              paidTo: {
                label:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                value:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
              },
              errorStatus: {
                ...prev.errorStatus,
                paidTo: false,
              },
              errorFields: {
                ...prev.errorFields,
                paidTo: "",
              },
            }));
          }
        }
        if (msg == "Receipt") {
          if (paymentMethod !== "ReceivedFrom") {
            setState1((prev) => ({
              ...prev,
              receivedTo: {
                label:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                value:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
              },
              errorStatus: {
                ...prev.errorStatus,
                receivedTo: false,
              },
              errorFields: {
                ...prev.errorFields,
                receivedTo: "",
              },
            }));
          } else {
            setState1((prev) => ({
              ...prev,
              receivedFrom: {
                label:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountName,
                value:
                  res.data.createBankDetails.RelatedAccountDetails?.[0].AccountsID,
              },
              errorStatus: {
                ...prev.errorStatus,
                receivedFrom: false,
              },
              errorFields: {
                ...prev.errorFields,
                receivedFrom: "",
              },
            }));
          }
        }
        setLoading(false);
        setState((prev) => ({
          ...prev,
          name: "",
          bankName: "",
          bankAccountNo: "",
          ifscCode: "",
          branch: "",
          accountType: "",
          errorStatus: {
            ...prev.errorStatus,
            name: false,
            bankName: false,
            bankAccountNo: false,
            ifscCode: false,
            branch: false,
            accountType: false,
          },
          errorFields: {
            ...prev.errorFields,
            name: "",
            bankName: "",
            bankAccountNo: "",
            ifscCode: "",
            branch: "",
            accountType: "",
          },
        }));
        setSnakbarText("Account created Successfully");
        setOpen(false)
        setsuccessSnakbar(true);
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function saveChanges() {
    const { name, bankAccountNo, bankName, ifscCode, accountType, branch } =
      state;
    const formData = {
      name,
      bankName,
      bankAccountNo,
      ifscCode,
      accountType,
      branch,
    };
    if (formValidation(formData)) {
      setBackdropOpen(true);
      setLoading(true);
      const bankDetails = {
        BankAccountNumber: state.bankAccountNo,
        BankName: state.bankName,
        Branch: state.branch,
        IFSCCode: state.ifscCode,
        Notes: "",
        ObjectID: companyDetails?.getCompany?.CompanyID,
        ObjectType: "COMPANY",
        LedgerAccount: state.name,
        AccountGroupID: 17,
        BankAccountType: state.accountType,
        Cash: 0.00
      };
      addBankDetails(bankDetails);
      setBackdropOpen(false);

    }
  }

  return (
    <Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        onClose={handleClose}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={backdropOpen}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  Add New Account
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>
            <Box sx={{ m: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: { sm: "flex-start" },
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  flexDirection: { xs: "column", sm: "row" },
                  margin: "0px",
                }}
              >
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.accountType == true ? true : false}
                    select
                    label="Bank Account Type"
                    name="accountType"
                    id="accountType"
                    fullWidth
                    onChange={(e) => {
                      const name = e.target.name;
                      const value = e.target.value;

                      if (value != "addgstrate") {
                        if (value === "") {
                          setState((prev) => ({
                            ...prev,
                            ["accountType"]: value,
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              ["accountType"]: true,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              ["accountType"]: "Bank Account Type is required",
                            },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            ["accountType"]: value,
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              ["accountType"]: false,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              ["accountType"]: "",
                            },
                          }));
                        }
                      }
                    }}
                    vakue={state.accountType}
                    required={true}
                    size="small"
                    sx={{
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                  >
                    {AccountTypes.map((item, ind) => {
                      return (
                        <MenuItem key={item.value} value={`${item.value}`}>
                          <ListItemText
                            sx={{ margin: "0px" }}
                            primary={item.option}
                          />
                        </MenuItem>
                      );
                    })}
                  </TextField>
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.accountType}
                  </Typography>
                </Box>

                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={
                      state.errorStatus.bankAccountNo == true ? true : false
                    }
                    label="Bank Account Number"
                    name="bankAccountNo"
                    id="bankAccountNo"
                    fullWidth
                    inputProps={{ maxLength: 34 }}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setState((prev) => ({
                          ...prev,
                          bankAccountNo: e.target.value,
                          errorFields: {
                            bankAccountNo: "Bank Account No is required",
                          },
                          errorStatus: {
                            bankAccountNo: true,
                          },
                        }));
                      } else {
                        if (!new RegExp(/^^\d{9,34}$/).test(e.target.value)) {
                          setState((prev) => ({
                            ...prev,
                            bankAccountNo: e.target.value,
                            errorFields: {
                              bankAccountNo: "Invalid Bank Account No",
                            },
                            errorStatus: {
                              bankAccountNo: true,
                            },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            bankAccountNo: e.target.value,
                            errorFields: {
                              bankAccountNo: "",
                            },
                            errorStatus: {
                              bankAccountNo: false,
                            },
                          }));
                        }
                      }
                    }}
                    size="small"
                    required={true}
                    sx={{
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.bankAccountNo}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: { sm: "flex-start" },
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  flexDirection: { xs: "column", sm: "row" },
                  marginBottom: "0px",
                }}
              >
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.ifscCode == true ? true : false}
                    label="IFSC Code"
                    name="ifscCode"
                    id="ifscCode"
                    fullWidth
                    value={state.ifscCode}
                    onChange={(e) => {
                      const value = e?.target?.value?.toUpperCase();
                      if (value.length > 11) {
                        return
                      }
                      // if (value == "") {
                      //   setState((prev) => ({
                      //     ...prev,
                      //     ["ifscCode"]: value,
                      //     ["errorStatus"]: {
                      //       ...prev.errorStatus,
                      //       ["ifscCode"]: true,
                      //     },
                      //     ["errorFields"]: {
                      //       ...prev.errorFields,
                      //       ["ifscCode"]: "IFSC Code is required",
                      //     },
                      //   }));
                      // } else
                      if (value != "") {
                        if (!new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/).test(value)) {
                          setBackdropOpen(false)
                          setState((prev) => ({
                            ...prev,
                            ["ifscCode"]: value,
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              ["ifscCode"]: true,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              ["ifscCode"]: "IFSC Code is invalid",
                            },
                          }));

                          setState((prev) => ({
                            ...prev,
                            ["bankName"]: "",
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              ["bankName"]: false,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              ["bankName"]: "",
                            },
                          }));
                          setState((prev) => ({
                            ...prev,
                            ["branch"]: "",
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              ["branch"]: false,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              ["branch"]: "",
                            },
                          }));

                        } else {
                          setBackdropOpen(true)
                          setState((prev) => ({
                            ...prev,
                            ["ifscCode"]: value,
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              ["ifscCode"]: false,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              ["ifscCode"]: "",
                            },
                          }));
                          IfscFetch(value)
                            .then((e) => {
                              console.log(e.data);

                              setState((prev) => ({
                                ...prev,
                                ["bankName"]: e.data?.bankName,
                                ["errorStatus"]: {
                                  ...prev.errorStatus,
                                  ["bankName"]: false,
                                },
                                ["errorFields"]: {
                                  ...prev.errorFields,
                                  ["bankName"]: "",
                                },
                              }));
                              setState((prev) => ({
                                ...prev,
                                ["branch"]: e.data.branchName,
                                ["errorStatus"]: {
                                  ...prev.errorStatus,
                                  ["branch"]: false,
                                },
                                ["errorFields"]: {
                                  ...prev.errorFields,
                                  ["branch"]: "",
                                },
                              }));
                              setBackdropOpen(false)
                            })
                            .catch((error) => {
                              setBackdropOpen(false)
                              showWarningSnackbar("IFSC not found in our database")
                              console.log(error);
                            })
                        }
                      } else {
                        setState((prev) => ({
                          ...prev,
                          ["ifscCode"]: "",
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["ifscCode"]: false,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["ifscCode"]: "",
                          },
                        }));
                        setState((prev) => ({
                          ...prev,
                          ["bankName"]: "",
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["bankName"]: false,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["bankName"]: "",
                          },
                        }));
                        setState((prev) => ({
                          ...prev,
                          ["branch"]: "",
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["branch"]: false,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["branch"]: "",
                          },
                        }));
                      }
                    }}
                    size="small"
                    sx={{
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.ifscCode}
                  </Typography>
                </Box>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.bankName === true ? true : false}
                    name="bankName"
                    label="Bank Name"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={state.bankName}
                    onChange={(e) => {
                      const name = e.target.name;
                      const value = e.target.value;
                      if (value === "") {
                        setState((prev) => ({
                          ...prev,
                          ["bankName"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["bankName"]: true,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["bankName"]: "Bank Name is required",
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          ["bankName"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["bankName"]: false,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["bankName"]: "",
                          },
                        }));
                      }
                    }}
                    sx={{
                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: "14px",
                      },
                      label: {
                        fontSize: "14px",
                      },
                      ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                        fontSize: "14px",
                      },
                      ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                        color: "input.font",
                      },
                      ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        borderColor: "input.border",
                      },
                      ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                        color: "input.font",
                      },
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  ></TextField>
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.bankName}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: { sm: "flex-start" },
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  flexDirection: { xs: "column", sm: "row" },
                  marginBottom: "0px",
                }}
              >
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.branch == true ? true : false}
                    label="Branch"
                    name="branch"
                    required={true}
                    id="branch"
                    fullWidth
                    value={state.branch}
                    onChange={(e) => handleChange(e)}
                    size="small"
                    sx={{
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.branch}
                  </Typography>
                </Box>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.name == true ? true : false}
                    name="name"
                    id="name"
                    label="Ledger Account"
                    fullWidth
                    value={state.name}
                    inputProps={{ maxLength: 30 }}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setState((prev) => ({
                          ...prev,
                          name: e.target.value,
                          errorFields: {
                            name: "Ledger Account Name is required",
                          },
                          errorStatus: {
                            name: true,
                          },
                        }));
                      } else {
                        let isvalid = true;
                        ledger.map((item) => {
                          if (item.AccountName.toLowerCase() == e.target.value.toLowerCase()) {
                            isvalid = false;
                          }
                        });
                        if (isvalid == false) {
                          setState((prev) => ({
                            ...prev,
                            name: e.target.value,
                            errorFields: {
                              name: "Ledger Account Name already exists",
                            },
                            errorStatus: {
                              name: true,
                            },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            name: e.target.value,
                            errorFields: {
                              name: "",
                            },
                            errorStatus: {
                              name: false,
                            },
                          }));
                        }
                      }
                    }}
                    required={true}
                    size="small"
                    sx={{
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.name}
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  // padding : "15px",
                  // width:'100%',
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <Button
                  onClick={handleClose}
                  variant="outlined"
                  sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
                >
                  Cancel
                </Button>
                <LoadingButton
                  loading={loading}
                  disableRipple={true}
                  onClick={saveChanges}
                  variant="contained"
                  sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
                >
                  ADD
                </LoadingButton>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
};

export default AddBankAccount;
